













































import { Component, Mixins } from "vue-property-decorator";
import { IBulkAction } from "@/models/bulkactions";
import { UpmindObjectTypes } from "@/data/enums/objects";
import { DataModules } from "@/store/modules/data";
import { ISegmentTypes } from "@/data/enums/segments";
import BulkActionsTable from "@/components/app/admin/automation/bulkActionsTable.vue";
import AdminBrandId from "@/mixins/adminBrandId";
import { routeToAdminLogsFromBulkActions } from "@/data/filters/timeline";

@Component({
  components: {
    BulkActionsTable,
    "timeline-component": () =>
      import("@/components/app/global/timelineComponent/index.vue")
  }
})
export default class AdminClientBulkActionsView extends Mixins(AdminBrandId) {
  public $refs!: {
    bulkActionsTable: BulkActionsTable;
  };

  // Getters
  public get bulkActionsTableProps() {
    return {
      id: "BAC1",
      objectType: UpmindObjectTypes.CLIENT,
      rowEvents: (bulkAction: IBulkAction) => ({
        click: () => {
          if (this.isReadonlyView(bulkAction))
            return this.$router.push({
              name: "adminClientBulkActionsEdit",
              params: {
                bulkActionId: bulkAction.id
              }
            });
          else this.openAddEditBulkActionModal(bulkAction);
        }
      })
    };
  }

  // Methods

  public routeToAdminLogsFromBulkActions = routeToAdminLogsFromBulkActions;

  public isReadonlyView(bulkAction) {
    return !["bulk_action_scheduled", "bulk_action_draft"].includes(
      this.$_.get(bulkAction, "status.code")
    );
  }

  public openAddEditBulkActionModal(
    bulkAction: IBulkAction = {} as IBulkAction
  ) {
    this.$store.dispatch(`data/${DataModules.BULK_ACTIONS}/openAddEditModal`, {
      props: {
        bulkAction,
        segmentType: ISegmentTypes.CLIENT
      },
      events: {
        success: () => {
          this.$refs.bulkActionsTable.getData({ ignoreStored: true });
        }
      }
    });
  }
}
